import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Question8.css";
import Money from "./images/money.gif";
import Dollar from "./images/dollar.gif";

const Question8 = ({ onAnswer, userResponse }) => {
  const [animateOut, setAnimateOut] = useState(false);

  const question = {
    title:
      "What’s the highest price you would be willing to pay to receive expert guidance and tools that would save you years of struggle?",
    questionImage: Money,
    options: [
      { label: "199", image: Dollar },
      { label: "499", image: Dollar },
      { label: "999", image: Dollar },
      { label: "2,000+", image: Dollar },
    ],
  };

  const handleNext = () => {
    if (!userResponse[question.title]) {
      return;
    }

    setAnimateOut(true);
    setTimeout(() => {
      onAnswer(question.title, null);
    }, 1000);
  };

  return (
    <AnimatePresence>
      <motion.div
        className="question8-container"
        initial={{ opacity: 0, x: "10%" }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: "-100vw" }}
        transition={{ duration: 1 }}
      >
        {question.questionImage && (
          <motion.img
            className="question8-img"
            src={question.questionImage}
            alt="Question"
            initial={{ opacity: 0, x: "10%" }} 
            animate={{ opacity: 1, x: 0 }} 
            exit={{ opacity: 0, x: "-100vw" }} 
            transition={{ duration: 0.5 }} 
          />
        )}

        <motion.h2
          className="question8-head"
          initial={{ opacity: 0, x: "10%" }} 
          animate={{ opacity: 1, x: 0 }} 
          exit={{ opacity: 0, x: "-100vw" }} 
          transition={{ duration: 0.5, delay: 0.3 }} 
        >
          {question.title}
        </motion.h2>

        <div className="option8-container">
          {question.options.map((option, index) => (
            <motion.label
              key={index} 
              className={`radio8-option ${
                userResponse[question.title] === option.label ? "checked" : ""
              }`} 
              htmlFor={`option-${index}`} 
              initial={{ opacity: 0, x: "10%" }} 
              animate={{ opacity: 1, x: 0 }} 
              exit={{ opacity: 0, x: "-100vw" }} 
              transition={{
                duration: 0.5, 
                delay: 0.5 + index * 0.2, 
              }}
            >
              <input
                type="radio"
                id={`option-${index}`} 
                name={`question-${question.title}`} 
                value={option.label} 
                checked={userResponse[question.title] === option.label} 
                onChange={() => onAnswer(question.title, option.label)} 
              />

              <motion.img
                className="option8-img"
                src={option.image}
                alt={option.label}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }} 
                exit={{ opacity: 0, scale: 0.9 }} 
                transition={{ duration: 0.8 }} 
              />

              <span className="radio8-label">{option.label}</span>
            </motion.label>
          ))}
        </div>

        <motion.button
          type="submit"
          className="next-button"
          initial={{ opacity: 0, x: "10%" }} 
          animate={{ opacity: 1, x: 0 }} 
          exit={{ opacity: 0, x: "-100vw" }} 
          transition={{ duration: 0.5, delay: 1 }}
          onClick={handleNext}
          disabled={!userResponse[question.title]}
        >
          Next Question 
        </motion.button>
      </motion.div>
    </AnimatePresence>
  );
};

export default Question8;
